"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EToggleAutosubmitActionTypes = exports.ECheckPhoneActionTypes = void 0;
let ECheckPhoneActionTypes = exports.ECheckPhoneActionTypes = /*#__PURE__*/function (ECheckPhoneActionTypes) {
  ECheckPhoneActionTypes["Loading"] = "phoneAuth/checkPhone/loading";
  ECheckPhoneActionTypes["Succeed"] = "phoneAuth/checkPhone/succeed";
  ECheckPhoneActionTypes["Failed"] = "phoneAuth/checkPhone/failed";
  return ECheckPhoneActionTypes;
}({});
let EToggleAutosubmitActionTypes = exports.EToggleAutosubmitActionTypes = /*#__PURE__*/function (EToggleAutosubmitActionTypes) {
  EToggleAutosubmitActionTypes["Toggle"] = "phoneAuth/toggleAutosubmit";
  return EToggleAutosubmitActionTypes;
}({});